import { secureGet, securePost } from '../utils/HttpUtils';

const apiUrls = {
  roles: '/v1/private/roles',
  users: '/v1/private/users',
  confirmUserPassword: (userId: string) => `/confirmacion/${userId}`,
};

export const getRoles = async () => {
  const url = apiUrls.roles;
  return secureGet(url);
};

export const saveUser = async (user: any) => {
  const url = apiUrls.users;
  return securePost(url, user);
};

export const getUsers = async (page: number, size: number) => {
  const url = `${apiUrls.users}?page=${page}&size=${size}`;
   try {
  return secureGet(url);
  } catch (error) {
    console.error(
      'Error fetching applications:',
      JSON.stringify(error, null, 2)
    );
    throw error;
  }
}
